<!--
 * @Author: mazhigang
 * @Date: 2023-07-01 19:16:24
 * @LastEditors: xjf
 * @LastEditTime: 2025-02-21 11:19:05
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>证件管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">证件管理</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="姓名">
                  <el-input
                    maxlength="50"
                    clearable
                    v-model="ruleForm.name"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="证件类型">
                  <el-select
                    style="margin-right: auto"
                    @change="selectCertificate"
                    v-model="ruleForm.status"
                    placeholder="请选择证件类型"
                  >
                    <el-option
                      :label="item.title"
                      :value="item.id"
                      v-for="(item, index) in certificate"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="等级">
                  <el-select
                    v-model="ruleForm.level"
                    placeholder="选择等级"
                    style="margin-right: auto; width: 150px"
                  >
                    <el-option
                      :label="item.propDesc"
                      :value="item.propValue"
                      v-for="(item, index) in ids"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="状态">
                  <el-select
                    style="margin-right: auto"
                    v-model="ruleForm.isJob"
                    placeholder="请选择状态"
                  >
                    <el-option label="未通过" value="0"></el-option>
                    <el-option label="已通过" value="1"></el-option>
                    <el-option label="待审核" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList('new')" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column label="姓名" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="careerTypeName"
            label="证件类型"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="certNumber" label="证件编号" align="center">
          </el-table-column>
          <el-table-column label="等级" align="center" width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.levelTypeName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="gmtCreate" label="审核状态" align="center">
            <template slot-scope="scope">
              <span
                :class="[
                  scope.row.verifyStatus == 0
                    ? 'redColor'
                    : scope.row.verifyStatus == 1
                    ? 'greenColor'
                    : 'blueColor',
                ]"
                >{{
                  scope.row.verifyStatus == 0
                    ? "未通过"
                    : scope.row.verifyStatus == 1
                    ? "通过"
                    : "待审核"
                }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="180"
          >
            <template slot-scope="scope">
              <div class="disAround">
                <div
                  class="operateBtn"
                  @click="handleEdit(scope.row)"
                  v-if="scope.row.verifyStatus == 2"
                >
                  审核
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="close(scope.row)"
                  v-if="scope.row.verifyStatus != 2"
                >
                  撤销审核
                </div>
                <div class="operateBtn" @click="goDetail(scope.row)">详情</div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="证件信息"
      :visible.sync="dialogVisible"
      width="900px"
      :before-close="handleClose"
    >
      <div class="infoBox">
        <div class="infoItem">证件类型：{{ selectData.careerTypeName }}</div>
        <div class="infoItem">证件等级：{{ selectData.levelTypeName }}</div>
        <div class="infoItem">姓名：{{ selectData.name }}</div>
        <div class="infoItem">证件号：{{ selectData.certNumber }}</div>
        <div style="display: flex; flex-wrap: wrap">
          <div class="infoItem" style="width: 200px; margin-right: 20px">
            <el-image
              :src="selectData.certFrontUrl"
              alt=""
              :preview-src-list="[selectData.certFrontUrl]"
            ></el-image>
          </div>
          <div class="infoItem" style="width: 200px; margin-right: 20px">
            <el-image
              :src="selectData.certOppositeUrl"
              alt=""
              :preview-src-list="[selectData.certOppositeUrl]"
            ></el-image>
          </div>
        </div>
        <div class="infoItem" style="width: 100%">
          <el-select
            style="margin-right: auto"
            v-model="state"
            placeholder="请选择审核状态"
          >
            <el-option label="通过" value="1"></el-option>
            <el-option label="拒绝" value="0"></el-option>
          </el-select>
        </div>
        <div class="infoItem" style="width: 100%" v-if="state == 1">
          <el-select
            style="margin-right: auto"
            v-model="level"
            placeholder="请选择等级"
          >
            <el-option
              :label="i.propDesc"
              :value="i.propValue"
              v-for="(i, i1) in ids"
              :key="i1"
            >
            </el-option>
          </el-select>
        </div>
        <div class="infoItem" v-if="state == '0'">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入拒绝原因"
            v-model="textarea"
          >
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="shenhe()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.askariData(),
      ruleForm: {
        name: "",
        status: "",
        level: "",
        isJob: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      certificate: [], //证件列表
      selectData: {},
      state: "",
      level: "",
      textarea: "",
      ids: [], //等级数据
      selectId: {}, // 证件选择的数据
    };
  },
  mounted() {
    this.getList();
    this.getCertificate();
  },
  methods: {
    //获取证件列表
    getCertificate() {
      let param = {
        key: "pricePremiumType_certs",
        orderColumn: "sort",
        isAsc: "1",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          let arr = JSON.parse(data[0].propValue);
          // for (var i = 0; i < arr.length; i++) {
          //   if (arr[i].level_key == "pricePremiumType_bodyguard_level") {
          //     arr.splice(i, 1);
          //   }
          // }
          this.certificate = arr;
        })
        .catch()
        .finally();
    },
    //证件下拉
    selectCertificate(val) {
      for (var i = 0; i < this.certificate.length; i++) {
        if (val == this.certificate[i].id) {
          this.selectId = this.certificate[i];
        }
      }
      this.getLevel();
    },
    //获取等级
    getLevel(val) {
      let param = {
        key: val ? val : this.selectId.lvKey,
        orderColumn: "sort",
        isAsc: "1",
      };
      this.$axios
        .post(`/admapi/sys/conf/getConfsByKey`, param)
        .then(({ data }) => {
          this.ids = data;
        })
        .catch()
        .finally();
    },
    //列表数据
    getList(val) {
      if (val == "new") {
        this.page = 1;
      }
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        name: this.ruleForm.name,
        verifyStatus: this.ruleForm.isJob,
        careerType: this.ruleForm.status,
        levelType: this.ruleForm.level,
      };
      this.$axios
        .post(`/admapi/bodyguard/certlist`, param)
        .then(({ data }) => {
          this.tableData = data.records ? data.records : [];
          this.total = data.total;
        })
        .catch()
        .finally();
    },
    //重置筛选
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.ruleForm.level = "";
      this.ruleForm.phone = "";
      this.ruleForm.isJob = "";
      this.selectlevelData = "";
      this.selectId = "";
      this.page = 1;
      this.getList();
    },
    //撤销审核
    close(val) {
      this.$confirm("是否撤销审核", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let param = {
          id: val.id,
        };
        this.$axios
          .post(`/admapi/bodyguard/cancelcertexamine`, param)
          .then(({ data }) => {
            this.$message({
              message: "撤销成功",
              type: "success",
            });
            this.getList();
          })
          .catch()
          .finally();
      });
    },
    //审核证件
    shenhe() {
      console.log(this.state);
      if (this.state == "") {
        this.$message({
          message: "请选择审核状态",
          type: "warning",
        });
        return;
      }
      if (this.state == 0) {
        if (this.textarea == "") {
          this.$message({
            message: "请输入拒绝原因",
            type: "warning",
          });
          return;
        }
      }
      let param = {
        bodyguardId: this.selectData.bodyguardId,
        certId: this.selectData.id,
        reason: this.textarea,
        levelType: this.level,
        state: this.state,
      };
      this.$axios
        .post(`/admapi/bodyguard/certexamine`, param)
        .then(({ data }) => {
          this.$message({
            message: "审核成功",
            type: "success",
          });
          this.dialogVisible = false;
          this.getList();
        })
        .catch()
        .finally();
    },
    //去详情
    goDetail(val) {
      this.$router.push({
        path: "/certificateDetail",
        query: {
          info: JSON.stringify(val),
        },
      });
    },
    //打开弹窗
    handleEdit(val) {
      for (var i = 0; i < this.certificate.length; i++) {
        if (val.careerType == this.certificate[i].id) {
          this.getLevel(this.certificate[i].lvKey);
        }
      }
      this.level = val.levelType.toString();
      this.state = "";
      this.textarea = "";
      this.selectData = val;
      this.dialogVisible = true;
    },
    handleClose() {
      this.state = "";
      this.textarea = "";
      this.selectData = {};
      this.dialogVisible = false;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.demo-ruleForm {
  width: 650px;
}

.infoBox {
}

.infoItem {
  width: 300px;
  margin-bottom: 10px;
}

.infoItem img {
  width: 200px;
  height: 150px;
}
</style>
